(function () {
  function hideEnglishGiftUi() {
    if (window.__srlBuyButtonsBound) return;
    window.__srlBuyButtonsBound = true;
    if (!window.location.pathname.includes('/en')) return;

    var comveyAccordion = document.getElementById('comvey-accordion');
    if (comveyAccordion) {
      comveyAccordion.style.display = 'none';
    }

    var observer = new MutationObserver(hideAnyGift);
    function hideAnyGift() {
      var anygiftElement = document.querySelector('[data-anygift="ProductPageGiftUi"]');
      if (anygiftElement) {
        setTimeout(function () {
          anygiftElement.style.setProperty('display', 'none', 'important');
        }, 500);
        observer.disconnect();
      }
    }

    observer.observe(document.body, { childList: true, subtree: true });
    hideAnyGift();
  }

  document.addEventListener('DOMContentLoaded', hideEnglishGiftUi);
})();
